// extracted by mini-css-extract-plugin
module.exports = {"ticket":"CyGuM","discount":"_2ismC","row":"_2VHwg","name":"_3m_im","singlePrice":"_3YUYB","price":"_3BzlI","quantity":"_38efq","total":"_22BqW","priceItem":"_2B2nr"};